export function initCounter() {
    const counters = document.querySelectorAll('.counter');
    const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
            if (!entry.isIntersecting) {
                continue;
            }

            const value = parseInt(entry.target.dataset.value);
            animate(value,  ((document.documentElement.dataset.c3accessibilityReduceMotion ?? '') === "" ?  3000 : 0), current => {
                entry.target.innerText = Math.round(current);
            });

            observer.unobserve(entry.target);
        }
    }, {
        threshold: 1
    });

    for (const counter of counters) {
        const displays = counter.querySelectorAll('.counter-item-display-value');
        for (const display of displays) {
            observer.observe(display);
        }
    }
}

/**
 *
 * @param {number} target
 * @param {number} duration
 * @param {(number) => void} callback
 */
function animate(target, duration, callback) {
    let start = 0;

    requestAnimationFrame(_run);

    /**
     * @param {number} ts
     */
    function _run(ts) {
        if (!start) {
            start = ts;
        }

        const diff = ts - start;
        const progress = Math.min(diff / duration, 1);

        callback(target * easing(progress));

        if (progress >= 1) {
            return;
        }

        requestAnimationFrame(_run);
    }
}

/**
 *
 * @param {number} x
 * @returns {number}
 */
function easing(x) {
    return x < 0.5
        ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2
        : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
}